// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"78905eb6","453":"18cd7ebe"}[chunkId] + ".chunk.js";
};